import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/lib/seo";
import { VILLES, zoneUrl } from "@/constants/zones";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="pt-[120px] md:pt-[170px] pb-24">
      <Seo
        title="Page introuvable | RAMA DÉCO"
        description="Cette page n'existe pas ou a été déplacée."
        path="/404"
        noindex
      />
      <div className="wrap max-w-3xl">
        <div className="font-mono-caption text-bordeaux-700 mb-4">Erreur 404</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-anthracite leading-[1.02]">
          Cette page n'existe <span className="italic text-bordeaux-700">plus.</span>
        </h1>
        <p className="mt-6 text-ink-soft text-base md:text-lg leading-relaxed">
          Le lien est peut-être ancien ou mal recopié. Voici les chemins les plus utiles pour retrouver ce que vous cherchiez.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <Link to="/" data-testid="notfound-home" className="btn-primary">Retour à l'accueil <ArrowRight size={16} /></Link>
          <Link to="/estimation" data-testid="notfound-estimation" className="btn-ghost">Estimer mon projet</Link>
        </div>

        <div className="mt-16">
          <div className="font-mono-caption text-ink-soft mb-4">Nos villes d'intervention</div>
          <ul className="flex flex-wrap gap-2">
            {VILLES.slice(0, 10).map((z) => (
              <li key={z.slug}>
                <Link to={zoneUrl(z.slug)} className="inline-flex px-4 py-2 bg-white border border-black/15 rounded-full text-sm text-anthracite hover:border-bordeaux-700 transition-colors">
                  {z.name}
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/blog/zones-intervention" className="mt-6 inline-block text-anthracite font-semibold link-underline">Toutes les zones →</Link>
        </div>
      </div>
    </div>
  );
}
